<template>
  <div class="computer-modules">


    <div v-if="modalOpened" class="madalbackground" @click="closeModals"></div>
    <!--</transition>-->
    <!--edit profile and new user forced-->

    <div class="container">
      <transition tag="div" name="slideUp">
        <div class="mandatory-modal p-3" v-if="paymentModal">
          <div class="title">
            <p>قوانین : {{this.name}}</p>
          </div>

          <div class="image-box d-flex justify-content-center">
            <img src="~@/assets/img/events/games/rules_1.png">
          </div>
          <div class="desc">
            <p v-html="this.steps"></p>
          </div>

          <div class="input-container">
            <!--<div class="container">
            </div>-->
            <div class="accept-rules d-flex align-items-center">
              <span @click="rules = !rules">
                قوانین را قبول دارم
              </span>

              <input class="rules" type="checkbox" v-model="rules" />
            </div>

          <router-link :to="{name: 'payment',params: { id:id,type:'مسابقات بازی های رایانه ای',title:name,image:image,des:des,price:price}}" tag="button" v-if="rules" class="btn buy-ticket active mt-2">
           خرید بلیط
          </router-link>

          <button v-else @click="acceptRules" class="btn buy-ticket disactive mt-2">
              خرید بلیط
          </button>
          <!--<button class="btn btn-outline-danger mt-2 w-100" @click="closePaymentModal">
            بستن
          </button>-->
          </div>

        </div>
      </transition>
    </div>




    <div class="title-container-box d-flex flex-column justify-content-center text-center mx-auto">
        <div class="image-box">
              <img src="~@/assets/img/events/games/games_item2.png">
        </div>
        <div class="computer-title">
          <h3>مسابقات بازی های رایانه ای</h3>
          <p>اگر فکر میکنی که تو بازی های رایانه ای مهارت داری<br> حتما خودت رو به این مسابقه برسون و با بقیه رقابت کن</p>
          <p>(اگه میخوای رقیب رو ببینی به بخش تورنومنت ها یه سر بزن)</p>
        </div>
    </div>
    <div class="computer-game-items d-flex justify-content-center flex-column p-4">

      <div class="mb-2 item-computer d-flex flex-column" v-for="data in lists">
          <div class="item-main-info d-flex flex-row">
            <div class="image-item d-flex align-items-end order-1">
              <img :src="`https://kishoto.ir/dtr/approid/img/${data.image}`">
            </div>
            <div class="main-item-box d-flex flex-column">
                <div class="title-item">{{data.name}}</div>
                <div class="desc-item">{{data.des}}</div>
            </div>
          </div>

          <div class="paymentbox-item d-flex flex-row justify-content-between">
            <div class="price-item order-2">قیمت بلیط: {{data.price | toPersianCurrency("تومان",0)}} </div>
            <div class="payment-btn-box" @click="openPaymentModal(data.id,data.name,data.des,data.steps,data.price,data.image)"><button class="btn buy-ticket">خرید بلیط</button> </div>
          </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      lists:null,
      modalOpened:false,
      paymentModal:false,

      id:null,
      name:null,
      des:null,
      steps:null,
      price:null,
      rules:false
    };
  },
  created(){
    this.getComputerItems();
  },
  computed: {

  },
  methods: {
    async getComputerItems() {

      let fd = new FormData();
      fd.append("games_id", 2);

      const response = await this.$ApiServiceLayer.post("get_list_games_a", fd);
      console.log(response);

      if (response) {
        this.lists = response;
        console.log(this.items);
      }
    },
    closeModals() {
      this.modalOpened = false;
      this.paymentModal = false;
    },
    openPaymentModal(id,name,des,steps,price,image){
      this.paymentModal = true;
      this.modalOpened = true;

      this.id = id;
      this.name = name;
      this.des = des;
      this.steps = steps;
      this.price = price;
      this.image = image;
    },
    closePaymentModal(){
      this.modalOpened = false;
      this.paymentModal = false;
    },

    acceptRules(){
      this.$toast.open({
        message: 'لطفا قوانین را بپذیرید',
        type: 'error',
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.computer-modules {
  width: 100%;
  min-height: 100%;
  height: 100%;
  background-image: url("~@/assets/img/bg/fifa_t_back.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /*  background: url("~@/assets/img/bg/fifa_t_back.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;*/

  .mandatory-modal {
    position: fixed;
    height: 500px;
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    //transform: translate(-50%, -50%);
    padding: 0px;
    direction: rtl;
    z-index: 2;
    overflow-y:scroll;
    overflow-x:hidden;
    border: 1px dashed #80808033;
    bottom: 0;
    left: 0;
    .title {
      width: 100%;
      height: 3px;
      /* background-color: blue; */
      /* margin-top: 40px; */
      text-align: center;
      /* position: relative; */
      margin-bottom: 51px;
      p {
        padding: 10px 20px;
        background-color: white;
        font-family: "sansb";
        font-size: 20px;
        font-weight: bold;
      }
    }
    .desc {
      width: 100%;
      padding: 0 20px;
      text-align: right;
      margin-top: 20px;
      padding-bottom: 30px;
      p {
        font-family: "sans";
        font-size: 17px;
        line-height: 28px;
        white-space: pre-line;
      }
    }
    .image-box{
      img{
        width: 135px;
        height: 180px;
      }
    }
    .input-container{
      position: fixed;
      bottom: 0px;
      height: auto;
      background: #ffffff;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      padding: 0px 0px 7px 9px;

      .accept-rules{
        input{
          margin-right: 11px;
          background: green;
          color: green;
        }
      }
      .buy-ticket.disactive{
        background: #959494;
        color:#ffffff;
        width: 50%;
        padding: 9px;
      }
      .buy-ticket.active{
        background: #8bc34a;
        color:#ffffff;
        width: 50%;
        padding: 9px;
      }
    }
  }

  .title-container-box{
    background: #ffffff;
    padding: 15px 15px 40px 15px;
    width: 92%;
    border-radius: 0 0 20px 20px;
    margin-bottom: 33px;
      .image-box{
        img{
          width: 130px;
          height: 130px;
          border-radius: 50%;
          margin-bottom: 20px;
          border: 2px solid #9e9e9e;
          box-shadow: 1px 1px 14px 2px #9e9e9ea1;
        }
      }

      .computer-title{
        h3{

        }
        p{
          color:#757575;
        }
      }
  }

  .computer-game-items{
    .item-computer{
      background: #ffffff;
      padding: 14px 14px 5px 14px;
      border-radius: 15px;

      .item-main-info {
        margin-bottom: 20px;
      .image-item {
        img {
          width: 67px;
          height: 67px;
        }
      }

      .main-item-box {
        padding-right: 16px;
        .title-item{
            text-align: right;
            direction: rtl;
            margin-bottom: 12px;
            font-size: 17px;
            font-weight: bold;
            color: #455a64;
        }
        .desc-item{
          text-align: right;
          color: #757575;
        }
      }

    }
    .paymentbox-item{
        .price-item{
          color:#f44336;
          display: flex;
          align-items: center;
        }
        .payment-btn-box{
          position: relative;
          .buy-ticket{
            background: #8bc34a;
            color: #ffff;
            height: 89%;
            align-items: center;
            display: flex;
            position: relative;
            right: 25px;
            padding: 7px 20px 8px 20px;
            border-radius: 8px;
          }
        }

      }
    }
  }

  .madalbackground{
    width: 100%;
    height: inherit;
    background: #0000006e;
    position: fixed;
    z-index: 1;
  }
}
</style>
